import { Component, inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

export class PdfPreviewDialogData {
  constructor(public readonly pdfUrl: string) {
  }
}

@Component({
  selector: 'lc-pdf-preview',
  templateUrl: './pdf-preview.dialog.component.html',
  styleUrls: ['./pdf-preview.dialog.component.scss'],
})
export class PdfPreviewDialogComponent {
  dialogRef = inject<MatDialogRef<PdfPreviewDialogComponent>>(MatDialogRef);
  readonly data = inject<PdfPreviewDialogData>(MAT_DIALOG_DATA);

  readonly url: SafeUrl;

  constructor() {
    const sanitizer = inject(DomSanitizer);
    const { data } = this;

    this.url = sanitizer.bypassSecurityTrustResourceUrl(data?.pdfUrl);
  }
}
